(() => {
  if (window.YulaCart) return;
  let busy = false;
  const cartURL = () => (window.Shopify?.routes?.root || '/') + 'cart';
  async function submit(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const form = event.currentTarget;
    const button = form.querySelector('[type="submit"]');
    if (busy || !button || button.disabled) return;
    busy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    let error = form.querySelector('[data-yula-cart-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.yulaCartError = '';
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }
    error.hidden = true;
    try {
      const body = new FormData(form);
      const selected = form.querySelector('input[name="yula_purchase"]:checked');
      const plan = selected?.dataset.planId || selected?.dataset.plan || '';
      if (plan) body.set('selling_plan', plan);
      else body.delete('selling_plan');
      body.set('sections', 'cart-drawer,cart-icon-bubble');
      body.set('sections_url', window.location.pathname);
      const response = await fetch(cartURL() + '/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || window.cartStrings?.error);
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') {
        window.location.assign(cartURL());
        return;
      }
      drawer.setActiveElement(button);
      try {
        await drawer.renderContents(data);
      } catch (renderError) {
        console.error('[Yula cart] Added successfully; opening cart after render failure.', renderError);
        window.location.assign(cartURL());
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    } catch (failure) {
      error.textContent = failure.message || window.cartStrings?.error;
      error.hidden = false;
    } finally {
      busy = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
  function bind() {
    document.querySelectorAll('[data-yula-form], [data-yv-form]').forEach(form => {
      if (form.dataset.yulaCartBound) return;
      form.dataset.yulaCartBound = 'true';
      form.addEventListener('submit', submit, true);
    });
  }
  window.YulaCart = { bind };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
